import AuthService from "../login/auth.service";
import { dimo } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class ComprobanteOperacionQRService {
  async listaComprobanteQR(mes) {
    var data = JSON.stringify({ mes: mes });
    var config = {
      method: "post",
      url: dimo + "v3/qr/listaComprobanteQR",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

}
export default new ComprobanteOperacionQRService();
